var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature3Icon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64782 4.86527H25.1045C25.1142 4.86527 25.1256 4.86615 25.1371 4.86615C25.7854 4.86615 26.3105 4.34098 26.3105 3.69266C26.3105 3.04433 25.7854 2.51917 25.1371 2.51917C25.1256 2.51917 25.1142 2.51917 25.1027 2.52004H25.1045H1.64782C1.01445 2.53852 0.507751 3.05665 0.507751 3.69266C0.507751 4.32867 1.01445 4.8468 1.64606 4.86527H1.64782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64782 9.55656H18.85C18.8597 9.55656 18.8711 9.55744 18.8825 9.55744C19.5308 9.55744 20.056 9.03227 20.056 8.38394C20.056 7.73562 19.5308 7.21045 18.8825 7.21045C18.8711 7.21045 18.8596 7.21045 18.8482 7.21133H18.85H1.64782C1.01445 7.2298 0.507751 7.74793 0.507751 8.38394C0.507751 9.01995 1.01445 9.53808 1.64606 9.55656H1.64782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1045 11.9036H1.64782C1.01445 11.9221 0.507751 12.4402 0.507751 13.0762C0.507751 13.7122 1.01445 14.2304 1.64606 14.2489H1.64782H25.1045C25.7379 14.2304 26.2446 13.7122 26.2446 13.0762C26.2446 12.4402 25.7379 11.9221 25.1063 11.9036H25.1045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1045 21.2862H1.64782C1.01445 21.3047 0.507751 21.8228 0.507751 22.4588C0.507751 23.0948 1.01445 23.6129 1.64606 23.6314H1.64782H25.1045C25.7379 23.6129 26.2446 23.0948 26.2446 22.4588C26.2446 21.8228 25.7379 21.3047 25.1063 21.2862H25.1045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64782 18.9401H18.85C19.4833 18.9217 19.99 18.4035 19.99 17.7675C19.99 17.1315 19.4833 16.6134 18.8517 16.5949H18.85H1.64782C1.01445 16.6134 0.507751 17.1315 0.507751 17.7675C0.507751 18.4035 1.01445 18.9217 1.64606 18.9401H1.64782Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5107,
    height: 25.5107,
    fill: "white",
    transform: "translate(0.474121 0.320801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3Icon3);
export default __webpack_public_path__ + "static/media/feature3-icon-3.db8bfda24adef4d1c61a4c8cdd255d3a.svg";
export { ForwardRef as ReactComponent };